import { LiveClassHistoryResponse } from '../../models/LCHistoryPageLiveClass';
import { LiveClassListItemProps } from '../../stories/LiveClassListItem';

/**
 * Parses the live history response data and returns a LiveClassListItemProps array.
 */
export const parseLiveHistoryResponse = (
  liveClassesData: LiveClassHistoryResponse | undefined,
): LiveClassListItemProps[] | undefined => {
  return liveClassesData?.data.map((liveClass) => {
    return {
      dateTime: liveClass.startAt,
      dateTimeLabel: liveClass.startAtLabel,
      name: liveClass.title,
      hasFeedback: liveClass.hasFeedback,
      feedback: liveClass.feedback,
      surveyUrl: liveClass.surveyUrl,
      recordingUrl: (liveClass.recordingUrls?.length && liveClass.recordingUrls[0]) || null,
    };
  });
};
